import React, {useState, useEffect} from 'react';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as departmentActions from '../../Redux/Actions/department';
import * as masterProcessActions from '../../Redux/Actions/masterProcess';
import * as processActions from '../../Redux/Actions/process';
import * as processCosts from '../../Redux/Actions/processCost';
import {toastMessage} from '../../utils/toast';
import { useSelector, useDispatch } from 'react-redux';
import { clearSession } from '../../utils/initiate';
import Warning from '../Ui/400';

const AddMaster = ({match, history}) => {

    let {type: masterType} = match.params;
    let typeName = masterType.includes('department') ? 'Department' : (masterType.includes('master') ? 'Master Process' : 'Process');

    let dropDownType = masterType.includes('department') ? '' : (masterType.includes('master') ? 'department' : masterType.includes('process') ? 'master-process' : '');
    const [dropDownData, setDropDownData] = useState([]);
    const [dropDownValue, setDropDownValue] = useState('');
    const [processCostData, setProcessCostData] = useState([]);
    const [processCostValue, setProcessCostValue] = useState('');
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [arabicName, setArabicName] = useState('');
    const [arabicDescription, setArabicDescription] = useState('');
    const [icon, setIcon] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const [isEnable, setIsEnable] = useState(true);
    const userData = useSelector(({User}) => User.data);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        let type = masterType.includes('department') ? '' : (masterType.includes('master') ? departmentActions : masterType.includes('process') ? masterProcessActions : '');
        (type !== '') && type.getAll().then(res => {
            if(res && res.data){
                setDropDownData(res.data);
            }else{
                setDropDownData([]);
                toastMessage('error', (res && res.message) || `Unable to load the ${typeName}`);
            }
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
        setName(''); setDescription(''); setArabicName(''); setArabicDescription(''); setIcon('');

        (typeName === 'Process') && masterType.includes('process') && processCosts.getAll().then(res => {
            if(res && res.data){
                setProcessCostData(res.data);
            }else{
                toastMessage('error', 'Unable to get the process costs');
            }
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    }, [masterType, typeName, dispatch, history, userData]);

    const handleAddMaster = () => {
        setButtonLoading(true);
        if((name !== '') && (description !== '')){
            let payload = {
                name, description, arabicName, arabicDescription
            };
            let dropDownID = (masterType.includes('master') ? 'departmentId' : masterType.includes('process') ? 'masterProcessId' : '');

            payload = (dropDownID === '') ? {...payload, icon}
               : {...payload, [dropDownID]: dropDownData && dropDownData.filter(({name}) => name === dropDownValue)[0]?.id};
            payload = (typeName === 'Process') ? {...payload, processCostId: processCostData && processCostData.filter(({name}) => name === processCostValue)[0].id} : payload;

            if(['Master Process', 'Process'].includes(typeName)) {
                payload['isEnable'] = isEnable;
            }

            let type = masterType.includes('department') ? departmentActions : (masterType.includes('master') ? masterProcessActions : masterType.includes('process') ? processActions : '');
            (type !== '') && type.create(payload).then(res => {
                if(res && res.data){
                    history.push(`/master/manage/${masterType}`);
                    toastMessage('success', `${typeName} added successfully`);
                    setName(''); setDescription(''); setArabicName(''); setArabicDescription(''); setIcon(''); setDropDownValue('');
                }else{
                    toastMessage('error', `${typeName} added Failed`);
                }
                setButtonLoading(false);
            }).catch(err => {
                setErrStatus(err.response.status);
                (err.response.status === 401) && clearSession(dispatch, history);
            });
        }else{
            setButtonLoading(false);
            toastMessage('error', `Enter the correct ${typeName} details`);
        }
    }

    if(errStatus === 400){
        return <Warning history={history} />
    }

    return(
        <>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    <div className="card border-0 card-stretch">
                        <div className="card-header border-0 py-3">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder text-dark">{t(`mastersManagement.${masterType}.addTitle`)}</span>
                            </h3>
                        </div>
                        <div className="card-body pt-0 pb-3">
                            {(dropDownType !== '') && <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t(`mastersManagement.${dropDownType}.dropDown`)}</label>
                                <select className="form-select me-3" value={dropDownValue} onChange={e => setDropDownValue(e.target.value)}>
                                    <option value="" disabled={true}>{t(`mastersManagement.${dropDownType}.dropDownPlaceholder`)}</option>
                                    {dropDownData && dropDownData.map(({name, id}) => <option key={id} value={name}>{name}</option>)}
                                </select>
                            </div>}
                            {(masterType === 'process') && <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("mastersManagement.add.processCost")}</label>
                                <select className="form-select me-3" value={processCostValue} onChange={e => setProcessCostValue(e.target.value)}>
                                    <option value="" disabled={true}>{t('mastersManagement.add.processCostPlaceholder')}</option>
                                    {processCostData && processCostData.map(({name, id}) => <option key={id} value={name}>{name}</option>)}
                                </select>
                            </div>}
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("mastersManagement.add.name")}</label>
                                <input placeholder={t("mastersManagement.add.namePlaceholder")} type="text" className="form-control"
                                    name="name" value={name} onChange={e => setName(e.target.value)}
                                />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("mastersManagement.add.arabicName")}</label>
                                <input placeholder={t("mastersManagement.add.arabicNamePlaceholder")} type="text" className="form-control"
                                    name="arabic  name" value={arabicName} onChange={e => setArabicName(e.target.value)}
                                />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("mastersManagement.add.description")}</label>
                                <input placeholder={t("mastersManagement.add.descriptionPlaceholder")} type="text" className="form-control"
                                    name="description" value={description} onChange={e => setDescription(e.target.value)}
                                />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("mastersManagement.add.arabicDescription")}</label>
                                <input placeholder={t("mastersManagement.add.arabicDescriptionPlaceholder")} type="text" className="form-control"
                                    name="arabic description" value={arabicDescription} onChange={e => setArabicDescription(e.target.value)}
                                />
                            </div>
                            {masterType.includes('department') && <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("mastersManagement.add.icon")}</label>
                                <input placeholder={t("mastersManagement.add.iconPlaceholder")} type="text" className="form-control"
                                    name="email" value={icon} onChange={e => setIcon(e.target.value)}
                                />
                            </div>}
                            {['Master Process', 'Process'].includes(typeName) && <div className="form-group fv-plugins-icon-container">
                                <input type="checkbox" checked={isEnable} onChange={() => setIsEnable(preState => !preState)}/>
                                <label className="mx-2">{t("mastersManagement.add.isEnableMobileDialer")}</label>
                            </div>}
                            <button disabled={buttonLoading} onClick={handleAddMaster} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold mb-3">
                                {t("mastersManagement.add.add")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddMaster;